import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const socketStoreSync = io(`${socketBaseUrl}/store-sync-progress`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default socketStoreSync;
